// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPayment_root__9N-_2"};